exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "* {\n  vertical-align: baseline;\n  font-weight: inherit;\n  font-family: inherit;\n  font-style: inherit;\n  font-size: 100%;\n  border: 0 none;\n  padding: 0;\n  margin: 0;\n}\nul {\n  list-style: none;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/~/css-loader?{"sourceMap":false,"importLoaders":1}!/home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/~/postcss-loader?{"ident":"postcss"}!/home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/~/less-loader/dist/cjs.js?{"sourceMap":false}!/home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/styles/_reset.less
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../less-loader/dist/cjs.js?{"sourceMap":false}!../../../../../src/styles/_reset.less
// module chunks = 3